export default {"src":"/_next/static/media/report.a0d6b7dd.svg","height":213,"width":190,"blurWidth":0,"blurHeight":0};